import { axios, Response } from '../index'
import { AccessProfile } from '../operators/get-clinic-operators'

export interface Therapist {
  id: string
  login: string
  avatarUrl: string
  firstName: string
  lastName: string
  cpfOrPassport: string
  email: string
  accessProfiles: AccessProfile[]
}

const getTherapistById = (therapistId: string): Response<Therapist> => {
  return axios.get(`/v1/therapists/${therapistId}`)
}

export default getTherapistById
